// Copyright (c) 2020 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import {
  SearchTagsRequestSchema,
  UpdateTagRequestSchema,
  CreateFavouriteTagRequestSchema,
  DeleteFavouriteTagRequestSchema,
  ReorderFavouriteTagRequestSchema,
  CreateTagKeywordRequestSchema,
  DeleteTagKeywordRequestSchema,
  GetTagRequestSchema,
  GetTagCategoryRequestSchema,
} from "generated/legebill/site/tag/v4/tag_pb"
import { Init } from "../../app/rpc"

export type FetchFavouriteTagsPayload = {
  siteId: string,
  swallowFailure?: boolean,
}

export type FetchRecentTagsPayload = {
  swallowFailure: boolean,
}

export type DeleteFavouriteTagPayload = {
  request: Init<typeof DeleteFavouriteTagRequestSchema>,
  siteId: string,
}

export type ReorderFavouriteTagPayload = {
  request: Init<typeof ReorderFavouriteTagRequestSchema>,
  siteId: string,
}

export type GetTagPayload = {
  request: Init<typeof GetTagRequestSchema>,
  swallowFailure?: boolean,
}

export type ListTagsByCategoryPayload = {
  tagCategoryId: string,
  swallowFailure?: boolean,
}

export const getTag = createAction<GetTagPayload>("tags/get-tag")
export const getTagCategory = createAction<Init<typeof GetTagCategoryRequestSchema>>("tags/get-tag-category")
// fetches recent tags for the active day of current site
export const fetchRecentTags = createAction<FetchRecentTagsPayload | undefined>("tags/fetch-recent-tags")
export const updateTag = createAction<Init<typeof UpdateTagRequestSchema>>("tags/update-tag")
export const fetchFavouriteTags = createAction<FetchFavouriteTagsPayload>("tags/fetch-favourite-tags")
export const searchTags = createAction<Init<typeof SearchTagsRequestSchema>>("tags/search-tags")
export const searchTagsShallow = createAction<Init<typeof SearchTagsRequestSchema>>("tags/search-tags-shallow")
export const createFavouriteTag = createAction<Init<typeof CreateFavouriteTagRequestSchema>>("tags/create-favourite-tag")
export const deleteFavouriteTag = createAction<DeleteFavouriteTagPayload>("tags/delete-favourite-tag")
export const reorderFavouriteTag = createAction<ReorderFavouriteTagPayload>("tags/reorder-favourite-tag")

export const createTagKeyword = createAction<Init<typeof CreateTagKeywordRequestSchema>>("tags/create-tag-keyword")
export const deleteTagKeyword = createAction<Init<typeof DeleteTagKeywordRequestSchema>>("tags/delete-tag-keyword")

export const listTagsByCategory = createAction<ListTagsByCategoryPayload>("tags/list-tags-by-category")
export const batchGetTagCategories = createAction<string[]>("tags/batch-get-tag-categories")

export const orderByPersisted = createAction("tags/order-by-persisted")
export const orderByPersistFailed = createAction("tags/order-by-persist-failed")
export const recentOrderByPersisted = createAction("tags/recent-order-by-persisted")
export const recentOrderByPersistFailed = createAction("tags/recent-order-by-persist-failed")
export const viewModePersisted = createAction("tags/view-mode-persisted")
export const viewModePersistFailed = createAction("tags/view-mode-persist-failed")
export const loadOrderByFromStorage = createAction("tags/load-order-by-from-storage")
export const loadOrderByFromStorageFailed = createAction("tags/load-order-by-from-storage-failed")
export const loadRecentOrderByFromStorage = createAction("tags/load-recent-order-by-from-storage")
export const loadRecentOrderByFromStorageFailed = createAction("tags/load-recent-order-by-from-storage-failed")
export const loadViewModeFromStorage = createAction("tags/load-view-mode-from-storage")
export const loadViewModeFromStorageFailed = createAction("tags/load-view-mode-from-storage-failed")
